import { map as _map } from 'lodash';
import { without as _without } from 'lodash';
import moment from 'moment';

class ExpiringContactsController {
  constructor(authService, userService, loadingService, $scope, $ngConfirm, contactService, growl) {
    "ngInject";

    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.contactService = contactService;
    this.growl = growl;

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    }; 

    this.overrideUserId = null;
    this.contacts = [];

    $scope.$on('dashboard:viewExpiringContactsStats', this.loadStats.bind(this));
    $scope.$on('dashboard:viewExpiringContacts', this.viewExpiringContacts.bind(this));
  }

  loadStats(evt, params) {    
    const ctrl = this;

    ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');
    
    this.overrideUserId = params ? params.userId : null;

    ctrl.userService.expiringContactsStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId)
      .then(response => {        
        ctrl.pagination.totalItems = response.data;
        ctrl.onLoadStats({count: response.data});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('contactList');
      });
  }  

  viewExpiringContacts(evt, params) {
    //Toggle Event coming from dashboard instead of page change, skip the method
    if (evt && this.contacts.length && !params.reload){
      return;
    }        
    const ctrl = this;

    ctrl.loadingService.showLoading('contactList', 'Loading Expiring Contacts');

    ctrl.userService.expiringContacts(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage)
      .then(response => {
        ctrl.contacts = response.data;
        ctrl.contacts = _map(ctrl.contacts, this.convertContact.bind(this));   
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('contactList');
      });
  }

  nukeContactConfirm(contact){
    this.$scope.contact = contact;

    this.$ngConfirm({
      title: `Delete Contact`,
      contentUrl: `templates/dashboard/nukeContactConfirmTemplate`,
      typeAnimation: false,
      columnClass: 'm',
      type: 'red',
      scope: this.$scope,
      buttons: {
        yes: {
              text: 'Anonymize this Contact',
              btnClass: 'btn-danger',
              action: () => { this.nukeContact(contact); }
        },        
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });
  }

  nukeContact(contact) {
    this.loadingService.showLoading('contactList', 'Anonymizing Contact ...');

    this.contactService.anonymize(contact.contactId)
      .then(response => {
        this.growl.success('Contact Anonymized Successfully ...', {ttl: 5000});
        this.contacts = _without(this.contacts, contact);
      })
      .finally(() => {
        this.loadingService.hideLoading('contactList');
      });    
  }

  isEmptyOrSpaces(str){
    return str === null || str.match(/^ *$/) !== null;
  }

  convertContact(contact) { 
    let reason;

    switch(contact.category){
      case 1:            
        reason = `Contact has been inactive for over ${moment().add(contact.daysOver, 'd').fromNow(true)}`;
        break;

      case 2:
        reason = `Due date for contact's promise lapsed ${moment().add(contact.daysOver, 'd').fromNow(true)} ago`;
        break;

      case 3:
        reason = `A Lost Enquiry for contact was created ${moment().add(contact.daysOver, 'd').fromNow(true)} ago`;
        break;

      case 4:
        reason = `An Open Enquiry for contact was created ${moment().add(contact.daysOver, 'd').fromNow(true)} ago`;
        break;            
        
      case 5:
        reason = `An Enquiry was Closed for contact ${moment().add(contact.daysOver, 'd').fromNow(true)} ago`;
        break;                    
    }

    return {
      contactId: contact.contactId, 
      contactName: this.isEmptyOrSpaces(contact.contactName) ? 'Blank' : contact.contactName, 
      timeRemaining: contact.timeRemaining, 
      timeRemainingText: contact.timeRemaining, 
      salesPerson: contact.salesPerson, 
      lastModified: contact.lastModifiedBySalesPerson,
      reason
    };    
  }
}

export default ExpiringContactsController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/expiringContacts/expiringContacts.controller.js